import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { getWorksheet } from '../../api/worksheets';
import useFocusOnMount from '../../hooks/useFocusOnMount';
import Button from '../../components/common/Button';
import CloudBand from '../../components/common/CloudBand';
import WorksheetPreviewContent from './WorksheetPreviewContent';
import s from './WorksheetPreviewPage.module.css';

export default function WorksheetPreviewPage() {
  const { worksheetId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useFocusOnMount();

  const [worksheet, setWorksheet] = useState(
    location.state?.worksheet || null
  );
  const [loading, setLoading] = useState(!worksheet);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (worksheet) return;
    if (!worksheetId) {
      navigate('/workbook', { replace: true });
      return;
    }
    setLoading(true);
    getWorksheet(worksheetId)
      .then((data) => setWorksheet(data))
      .catch((err) => setError(err.message || 'Failed to load worksheet.'))
      .finally(() => setLoading(false));
  }, [worksheetId, worksheet, navigate]);

  if (loading) {
    return (
      <div className={s.loadingPage} aria-live="polite">
        <p className={s.loadingText}>Loading worksheet...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={s.errorPage}>
        <p className={s.errorText}>{error}</p>
        <Button onClick={() => navigate('/workbook', { replace: true })}>
          Back to Workbook
        </Button>
      </div>
    );
  }

  return (
    <main className={s.page} ref={mainRef} tabIndex={-1}>
      <CloudBand variant="teal" className={s.cloudBand} />
      <div className={s.content}>
        {/* Back button */}
        <div className={s.backRow}>
          <Button variant="back" onClick={() => navigate('/workbook')}>
            Back
          </Button>
        </div>
        <WorksheetPreviewContent
          worksheet={worksheet}
          onClose={() => navigate('/workbook')}
        />
        <div className={`${s.actionArea} ${s.actionAreaNoTopMargin}`}>
          <Button
            variant="secondary"
            className={s.fullWidthBtn}
            onClick={() => navigate('/workbook')}
          >
            Back to Workbook
          </Button>
        </div>
      </div>
    </main>
  );
}
